export default __webpack_public_path__ + "static/media/07.bad6f914.jpg";